import {AbstractModel} from '../abstract-model';

export class FormWidget extends AbstractModel {
  slug: string = '';
  name: string = '';
  defaultLang = 'en';
  authorizedLanguages: string[] = ['en', 'fr', 'es', 'de', 'pt'];
  folderSet: number | null = null;
  authorizedFolderSet: number | null = null;
  gridFormat: number | null = null;
  authorizedGridFormat: number[] | null = null;
  sourceType: string = '';
  sourceDetails: string[] = [];

  override toString(): string {
    return this.name;
  }

  getGridClass(): string {
    if (this.gridFormat === 4) {
      return 'col-3';
    }
    if (this.gridFormat === 3) {
      return 'col-4';
    }
    if (this.gridFormat === 2) {
      return 'col-6';
    }

    return 'col';
  }
}
